import React, { useState, useEffect, useContext, useRef } from "react";
import { Link } from 'react-router-dom';
import axios from "axios";
import sgllogo from '../images/sgllogo.png'
import SglContext from '../SglContext'
import './results.css'

function DailyResults(props) {
    const [classes, setClasses] = useState([]);
    const [loose_class_heading, setLooseClassHeading] = useState("");
    const [current_show, setCurrentShow] = useState(localStorage.getItem('show_id'));
    const [show_days_list, setShowDaysList] = useState([]);
    const [show_date, setShowDate] = useState('00/00/00');
    const [show_name, setShowName] = useState("");
    const [display_date, setDisplayDate] = useState("");
    const [loading, setLoading] = useState(true);
    const [TimeOutCounter, setTimeOutCounter] = useState(0)
    const [TimeOutInterval, setTimeOutInterval] = useState(0)
    const latestRequestRef = useRef(0);
    const Sgl = useContext(SglContext)
    
    
    const openTab = (tabName) => {
        appendDateToURL(tabName)
        setShowDate(tabName)
        getDailyResultsData(tabName, current_show, false);
    }
    function getQueryVariable(variable) {
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
          var pair = vars[i].split("=");
          if (pair[0] == variable) {
            return pair[1];
          }
        }
        return false;
      }
    
      const appendDateToURL = (date) => {
        var url = window.location.href,
          newurl;
        if(date == '') {
          newurl = url.replace(/[?]date=(.*)/, "");
          newurl = newurl.replace(/&date=(.*)/, "");
        }
        else if (url.search("&date=") > 0) {
          newurl = url.replace(/&date=(.*)/, "&date=" + date);
        } else if (url.indexOf("?date=") > 0) {
          newurl = url.replace(/[?]date=(.*)/, "?date=" + date);
        } else {
          newurl = url + (url.indexOf("?") > 0 ? "&" : "?") + "date=" + date;
        }
        window.history.pushState(date, "", newurl);
      };

    const getDailyResultsData = (show_date, show, set_show_date = true) => {
        const requestId = ++latestRequestRef.current;

        axios.get(Sgl.nestApiUrl + '/results/daily', {
            params: {
                date: show_date,
                show_id: show,
                customer_id: Sgl.company_id
            }
        }).then(results => {
            if (requestId === latestRequestRef.current) {
                setClasses(results.data.classes)
                setLooseClassHeading(results.data.loose_class_heading)
                setCurrentShow(results.data.show_id)
                setShowName(results.data.show_name)
                setShowDaysList(results.data.show_days_list)
                if(set_show_date){
                    setShowDate(results.data.result_date)
                }
                setDisplayDate(results.data.display_date)
                setLoading(false)

                document.title = "Results for " + results.data.show_name + " (" + results.data.display_date + ")";
                Sgl.reportToGA('/sgl-wp-plugin/' + Sgl.company_path + '/' + show + '/results/daily/' + results.data.result_date);
                Sgl.reportToFB('/sgl-wp-plugin/' + Sgl.company_path + '/' + show + '/results/daily/' + results.data.result_date);
            }
        })
    }

    useEffect(() => {
        let current_date = show_date;

        if(props.currentShow != current_show && props.currentShow != 0 && current_show != 0 && !loading) {
            setShowDate('')
            appendDateToURL('')
            current_date = ''
        }
        if (loading) {
            current_date = getQueryVariable("date") ? getQueryVariable("date"): "00/00/00"
            setShowDate(current_date);
        }
        getDailyResultsData(current_date, props.currentShow);
    }, [props.currentShow, show_date]); // add props as dependencies

    // useEffect(() => { // ComponentDidMount
    //     let current_date = show_date;
    //     if (loading) {
    //         current_date = getQueryVariable("date") ? getQueryVariable("date"): "00/00/00"
    //         setShowDate(current_date);
    //     }
    //     getDailyResultsData(current_date, current_show)
    // }, [])



    if (loading) {
        return null;
    }

    return (
        <div id='section-to-print' class="section-to-print resultscss">
        <section className="search-area">
            <h2 className="sgl-h2">Results for {show_name} ({display_date})</h2>
            <div className='credit-text'> {process.env.REACT_APP_CREDIT_TEXT}{" "} <a onClick={() => window.open(`https://www.showgroundslive.com`, '_blank', 'noopener,noreferrer')}> {process.env.REACT_APP_CREDIT_COMPANY} </a> </div><br />
            <div class="tab no_print">
                {
                    show_days_list.map((day) => {
                        let default_tab = "tablinks element" + (show_date === day.date ? " active" : "");
                        return (
                            <button className={default_tab} onClick={(e) => openTab(day.date)} id={day.date}>
                                {day.day}
                            </button>
                        )
                    })
                }
                <a class='result_print' onClick={() => window.print()}><img class='printer-icon' src={require('../images/printer.png')} /> Print</a>

            </div>
            {(classes.length > 0) ?
                <div class="div-responsive">
                    <table class="table table-hover table-striped">
                        <thead class="classes-header">
                            <tr class="sgl-primary-header">
                                <th colspan="8" align="center">
                                    {loose_class_heading}{((classes[0].sponsor) ? ' - Sponsored By: ' + classes[0].sponsor : "")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                classes.map((data, index) => {
                                    return (
                                        <tr class="sgl-anchor">
                                            <td><Link to={'/classes/detail?cid=' + data.class_id + '&sid=' + current_show}>{data.number} - {data.name} {((data.sponsor) ? <span class='sponsor_text'> (Sponsored By: {data.sponsor})</span> : "")}</Link></td>
                                        </tr>
                                    )
                                })
                            }

                        </tbody>
                    </table>
                </div>
                : <div>No Results found</div>
            }
            
            <div id="print_footer" className="print_block print_footer">
            <img className='footer_logo' src={sgllogo} />Copyright © {(new Date().getFullYear())} · All rights reserved · ShowGrounds, LLC. · Shelburne Falls MA · 1-888-429-9495     
            </div>
            <div className="copyright-text no_print">{process.env.REACT_APP_COPYRIGHT_TEXT}</div>
        </section>
        </div>
    )
}

export default DailyResults;